// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMobileAppFeedbackReminderResponseDto
 */
export interface IMobileAppFeedbackReminderResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof IMobileAppFeedbackReminderResponseDto
     */
    remind?: boolean;
}

/**
 * Check if a given object implements the IMobileAppFeedbackReminderResponseDto interface.
 */
export function instanceOfIMobileAppFeedbackReminderResponseDto(value: object): value is IMobileAppFeedbackReminderResponseDto {
    return true;
}

export function IMobileAppFeedbackReminderResponseDtoFromJSON(json: any): IMobileAppFeedbackReminderResponseDto {
    return IMobileAppFeedbackReminderResponseDtoFromJSONTyped(json, false);
}

export function IMobileAppFeedbackReminderResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMobileAppFeedbackReminderResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'remind': json['remind'] == null ? undefined : json['remind'],
    };
}

export function IMobileAppFeedbackReminderResponseDtoToJSON(json: any): IMobileAppFeedbackReminderResponseDto {
    return IMobileAppFeedbackReminderResponseDtoToJSONTyped(json, false);
}

export function IMobileAppFeedbackReminderResponseDtoToJSONTyped(value?: IMobileAppFeedbackReminderResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remind': value['remind'],
    };
}

